import styles from "./AddressInput.module.css"
import React from 'react';
import { ChevronDown, ChevronUp, MapPin } from 'lucide-react';
import { useTranslation } from "react-i18next";
import { useDropdown } from "../../../hooks/useDropdown";
/**
* Props for the AddressInput component.
*/ 
interface AddressInputProps {
    text?: string, // Input label
    onChange?: (value: string) => void, // Change event handler
    value?: string, // Current value
    addresses?: string[], // List of options
    className? :string, // Optional additional class
    wrapperClassName?: string; // Optional additional wrapper class
    showOnly?: boolean // Whether the input should be show only
} 
/**
* An address input component with optional label and dropdown options.
*
* @param props AddressInput props
* @param {string} props.text - Input label
* @param {(value: string) => void} props.onChange - Change event handler
* @param {string} props.value - Current value
* @param {string[]} props.addresses - List of options
* @param {string} props.className - Optional additional class
* @param {string} props.wrapperClassName - Optional additional wrapper class
* @param {boolean} props.showOnly - Whether the input should be show only
* @returns TSX.Element
*/
const AddressInput: React.FC<AddressInputProps> = ({ text, showOnly = false , addresses,  onChange, value, className, wrapperClassName}) => {
    const { t } = useTranslation(); // Translation
    const { ref, isOpen, setIsOpen } = useDropdown(); // Dropdown hook
    
    // Show only mode
    if (showOnly === true) {
        return(
            <>
                <div className={wrapperClassName? `${styles.AddressInputBlock} ${wrapperClassName}` : `${styles.AddressInputBlock}`} ref={ref}>
                    <div className={className? `${styles.AddressInputCenter} ${className}` : `${styles.AddressInputCenter}`}>
                        <div className={styles.AddressInputIcon}>
                            <MapPin fill="#68102B" stroke="white" strokeWidth={2} />
                        </div>
                        <div className={styles.SelectedAddress}><p>{`${value?.substring(0, 30)}` || t("inputs.address_placeholder")}...</p></div>
                    </div>
                </div>
            </>
        )
    }

    return(
        <>
            <div className={wrapperClassName? `${styles.AddressInputBlock} ${wrapperClassName}` : `${styles.AddressInputBlock}`} ref={ref}>
                <div className={className? `${styles.AddressInputCenter} ${className}` : `${styles.AddressInputCenter}`} onClick={()=>setIsOpen(!isOpen)}>
                    <div className={styles.AddressInputIcon}>
                        <MapPin fill="#68102B" stroke="white" strokeWidth={2} />
                    </div>
                    <div className={styles.SelectedAddress}><p>{`${value?.substring(0, 30)}` || t("inputs.address_placeholder")}...</p></div>
                    {/*List the given Addresss */}
                    {isOpen && (
                        <div className={styles.AddressDropdown}>
                            {addresses?.map((address,i)=>(
                                <div 
                                className={styles.AddressDropdownItem} 
                                key={`${address}-${i}`}
                                onClick ={()=>{
                                    onChange && onChange(address)
                                    setIsOpen(false)
                                }}
                                >
                                    <p>{address.substring(0, 35)}...</p>
                                </div>  
                            ))}
                        </div>
                    )}
                    <button type="button" className={styles.AddressDropdownButton} >
                        {isOpen ? <ChevronUp /> : <ChevronDown />}
                    </button>
                </div>
            </div>
        </>
    )
};

export default AddressInput;